// extracted by mini-css-extract-plugin
export var actions = "_rc-4";
export var item = "_rc-1";
export var price = "_rc-3";
export var quantity = "_rc-2";
export var table = "_rc-0";